import { FC, useEffect } from "react";

import { ISettingOptions } from "../../../types/interfaces";

import styles from "../headerBtn.module.scss";

const options = [
  { value: 'name', label: 'ФИО' },
  { value: 'login', label: 'Логин' },
  { value: 'role', label: 'Роль' },
  { value: 'position', label: 'Должность' },
  { value: 'hasroute', label: 'Наличие маршрута' },
  { value: 'freelancer', label: 'Фрилансер' },
  { value: 'project', label: 'Проект' },
  { value: 'areas', label: 'Область' },
  { value: 'service', label: 'Служба' },
  { value: 'vsv', label: 'ВСВ' },
  { value: 'phone', label: 'Телефон' },
  { value: 'registrationDate', label: 'Дата оформления' },
  { value: 'startDate', label: 'Дата начала работы' },
  { value: 'createDate', label: 'Дата создания' },
  { value: 'verified', label: 'Верифицирован' },
];

const EmployeesListSettingsSection: FC<ISettingOptions> = ({
  setSelectedSettings,
  selectedSettings,
  setIsCheckedFullInfo,
  isCheckedFullInfo,
}) => {
  const handleChangeCheckbox = (name: string) => {
    const updatedSettings = selectedSettings.includes(name)
      ? selectedSettings.filter((elem: string) => elem !== name)
      : [...selectedSettings, name];
    setSelectedSettings(updatedSettings);
    setIsCheckedFullInfo(updatedSettings.length === options.length);
  };

  const handleChangeFullInfoCheckbox = () => {
    if (!isCheckedFullInfo) {
      const allSettings = options.map((option) => option.value);
      setSelectedSettings(allSettings);
    } else {
      setSelectedSettings([]);
    }
    setIsCheckedFullInfo(!isCheckedFullInfo);
  };

  useEffect(()=>{
    setIsCheckedFullInfo(selectedSettings.length === options.length);
    // eslint-disable-next-line
  },[]);
  return (
    <div className={styles.settings__block_info}>
      <div className={styles.check__list_block}>
        {options.map((option) => (
          <div key={option.value} className={styles.check__list_elem}>
            <label className={styles.checkbox__container}>
              <input
                checked={selectedSettings.includes(option.value)}
                type="checkbox"
                onChange={() => handleChangeCheckbox(option.value)}
              />
              <span className={styles.multi__reason_checkmark}></span>
            </label>
            {option.label}
          </div>
        ))}
        <div className={styles.check__list_elem}>
          <label className={styles.checkbox__container}>
            <input
              type={"checkbox"}
              onChange={handleChangeFullInfoCheckbox}
              checked={isCheckedFullInfo}
            />
            <span className={styles.multi__reason_checkmark}></span>
          </label>
          Все
        </div>
      </div>
    </div>
  );
};

export default EmployeesListSettingsSection;
